import { render, staticRenderFns } from "./PurchaseConfirmation2.vue?vue&type=template&id=516d9138&scoped=true"
import script from "./PurchaseConfirmation2.vue?vue&type=script&lang=js"
export * from "./PurchaseConfirmation2.vue?vue&type=script&lang=js"
import style0 from "./PurchaseConfirmation2.vue?vue&type=style&index=0&id=516d9138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d9138",
  null
  
)

export default component.exports